export function isExclusionGroupName(name: string): boolean {
  return name.toLowerCase().includes('exclusion');
}
